import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, Box, FlexBox, Page, Text, Tooltip, } from '@dixa/lib-shared-habla';
import { client as elevioClient } from 'elevio';
import { useCallback } from 'react';
import { shallowEqual } from 'react-redux';
import { appActions } from 'app/app.actions';
import { analytics } from 'app/utils/segment';
import { hasFeature } from 'components/shared/featureFlag';
import { categories } from 'utils/elevio';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import { getTooltipContent } from '../../utils/integrationTooltipContent/integrationTooltipContent';
import { useIntegrations } from '../../utils/useIntegrations/useIntegrations';
import { SettingsIntegrationsDocumentationButton } from '../documentationButton/documentationButton';
import styles from './integrations.module.scss';
export const Integrations = () => {
    const dispatch = useAppDispatch();
    const navigate = useAppNavigate();
    const integrations = useIntegrations();
    const { allFeatureFlags } = useAppSelector((state) => ({
        allFeatureFlags: state.settings.profile.featureflags,
    }), shallowEqual);
    const showFeedbackModal = useCallback(() => {
        dispatch(appActions.showModal({
            modal: {
                type: 'app:feedbackForm',
                arg: {
                    team: 'partners',
                    title: 'Feedback for conversation sidebar integrations',
                },
            },
        }));
    }, [dispatch]);
    const navigateToPartnerCreate = (key, widgetType) => {
        analytics.partnerIntegrationsSettingsOverviewCreated({
            widgetType,
        });
        navigate({
            path: '/settings/integrations/partner-widget/:type/create',
            params: {
                path: {
                    type: key,
                },
            },
        });
    };
    return (_jsxs(Page.Section, Object.assign({ title: "Create new integration", titleMeta: _jsx(_Fragment, { children: _jsx(SettingsIntegrationsDocumentationButton, { onClick: () => elevioClient.openCategory(categories.settings.integrations.documentation) }) }) }, { children: [_jsxs(FlexBox, Object.assign({ gap: "100", alignItems: "center" }, { children: [_jsx(Text.Paragraph, Object.assign({ as: "span", variant: "4" }, { children: "Missing an integration?" })), _jsx(Text.Paragraph, Object.assign({ as: "span", variant: "4", className: styles.externalLink }, { children: _jsx("span", Object.assign({ onClick: () => showFeedbackModal() }, { children: "Talk to us about your use case" })) }))] })), _jsx(FlexBox, Object.assign({ gap: "300", flexWrap: "wrap", flexDirection: "row", alignItems: "start", className: styles.integrations }, { children: Object.entries(integrations)
                    .filter(([key]) => integrations[key].featureFlag
                    ? hasFeature(allFeatureFlags, integrations[key].featureFlag)
                    : true)
                    .map(([key, { id, icon, label, iconColors, path, integrationType }]) => (_jsx(Tooltip, Object.assign({ content: getTooltipContent({
                        cardType: id,
                        integrationType,
                    }), dark: true }, { children: _jsxs(Box, Object.assign({ className: styles.integrationsItem, onClick: () => path
                            ? navigate({ path })
                            : navigateToPartnerCreate(key.toLowerCase(), id) }, { children: [_jsx(Avatar, { size: "40", icon: icon, color: iconColors }), _jsx(Text.Paragraph, Object.assign({ className: styles.integrationsItemLabel }, { children: label }))] })) }), id))) }))] })));
};
